import { gql } from "@apollo/client";

export const GoalCompentenciesFragments = gql`
  fragment GoalCompetencyFragment on CompetencyNode {
    id
    title
  }
  fragment GoalRoleFragment on CareerTrackRoleNode {
    id
    title
    level
    careerTrack {
      id
      title
    }
  }
  fragment GoalOwnerRoleCompetencyFragment on GoalArtifactToCompetencyM2MNode {
    id
    role {
      ...GoalRoleFragment
    }
    competency {
      ...GoalCompetencyFragment
    }
  }
  fragment GoalCompentenciesWithRoleFragment on GoalArtifactNode {
    competencyRelations {
      edges {
        node {
          ...GoalOwnerRoleCompetencyFragment
        }
      }
    }
  }
`;
export default gql`
  ${GoalCompentenciesFragments}
  fragment GoalOwnerRoleFragment on CareerTrackRoleNode {
    id
    title
    level
    careerTrack {
      id
      title
    }
    competencies {
      edges {
        node {
          ...GoalCompetencyFragment
        }
      }
    }
  }
  query getGoalGrowthConnectionsQuery($artifactId: Int!, $userId: Int!) {
    artifact(artifactId: $artifactId) {
      __typename
      id
      ... on GoalArtifactNode {
        ...GoalCompentenciesWithRoleFragment
      }
    }
    user(userId: $userId) {
      id
      currentRoles {
        ...GoalOwnerRoleFragment
      }
    }
  }
`;
